export enum TutorTimeSelect {
  TOTAL_TIME = 'total_time',
  HIGH_QUALITY_TIME = 'high_quality_time',
}